<template>
  <v-container fluid>
    <v-flex xs12>
      <v-card>
        <v-card-title>
          <span class="title">BlackList (ByBit/HTX)
            <v-text-field append-icon="search" label="Quick Search" single-line hide-details v-model="quickSearch"></v-text-field>
          </span>
          <v-spacer></v-spacer>
        </v-card-title>

        <v-data-table class="elevation-1" v-bind:headers="headers" v-bind:items="items" v-bind:search="search" hide-actions>
        <template slot="headers" slot-scope="props">
          <tr>
            <th v-for="(header, index) in props.headers" :key="header.text"
            :class="['column', 'subheading' , index === 0? 'text-xs-left': 'text-xs-center']">
              {{ header.text }}
            </th>
            <th>                
            </th>
          </tr>
        </template>
        <template class="body-2" slot="items" slot-scope="props">
          <td  v-for="(header, index) in headers" :key="index" 
              :class="[ index === 0 ? 'text-xs-left': 'text-xs-center', 'body-2']" v-if="header.value!==''">
            {{renderData(props.item, header)}}
          </td>
            <td class="text-xs-right">
            <v-btn class="teal" fab small dark @click.native="view(props.item)">
              <v-icon>list</v-icon>
            </v-btn>
          </td>
        </template>
        <template slot="no-data">
         <span >
            <p class="pt-2 blue--text subheading">   <v-icon medium class="blue--text" >info</v-icon>Sorry, nothing to display here :(</p>
          </span>
        </template>
      </v-data-table>
      </v-card>
    </v-flex>
      <v-snackbar v-if="loading===false" :right="true" :timeout="timeout" :color="mode" v-model="snackbar" >
      {{ notice }}
      <v-btn dark flat @click.native="closeSnackbar">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>
<script>
/* globals Store */
import Table from "@/components/Table.vue";
import { mapState } from "vuex";
import { debounce } from "lodash";

export default {
  components: {
    Table,
  },
  data () {
    return {
      right: true,
      search: '',
      headers: [
        { text: 'Площадка', left: true, value: 'market' },
        { text: 'Nick Name', left: true, value: 'nick_name' },
        { text: 'UID', value: 'market_id' },
        { text: 'Кол-во отзывов', value: 'count' },
        { text: 'Добавлен', value: 'report_time' },
      ],
      customerId: "",
      query: "",
      snackbarStatus: false,
      timeout: 2000,
      color: "",
      quickSearchFilter: "",
    }
  },
  methods: {
    view (item) {
      this.$router.push({ name: 'BlackForm', params: { id: item.market_id, nick_name: item.nick_name, link: item.link } })
    },
    dashboard () {
      this.$router.push('Dashboard')
    },
    renderData: (item, header) => {
      let val = "";
      if (header.value.includes('.')) {
        const vals = header.value.split('.')
        val = vals.reduce((acc, val) => acc[val], item)
      } else {
        val = item[header.value]
      }
      if (typeof val === "boolean") {
        val = val ? "Yes" : "No";
      }
      return val;
    },
    quickSearchCustomers: debounce(function () {
      console.log(this.quickSearchFilter)
      Store.dispatch("blacklist/quickSearch",
       { headers: this.headers,
         qsFilter: this.quickSearchFilter.toLowerCase(),
         pagination: this.pagination });
    }, 300),
  },
  computed: {
    ...mapState("blacklist", {
      items: "items",
      loading: "loading",
      mode: "mode",
      snackbar: "snackbar",
      notice: "notice"
    }),
    quickSearch: {
      get: function () {
        return this.quickSearchFilter;
      },
      set: function ( val ) {
        this.quickSearchFilter = val;
        this.quickSearchCustomers();
      }
    }
  },
  watch: {
    items() {
      this.$Progress.finish();
    },
  },
  created () {
    Store.dispatch("blacklist/quickSearch",
       { headers: this.headers,
         qsFilter: this.quickSearchFilter.toLowerCase(),
         pagination: this.pagination });
  },
}
</script>



// WEBPACK FOOTER //
// BlackList.vue?17fca01a